/* ZYRA v2 - interakcije (bez zavisnosti). */
(function () {
  'use strict';

  var root = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var FREE_SHIPPING = 599900;
  var TIERS = [
    { qty: 2, pct: 7 },
    { qty: 3, pct: 8, get: ' + poklon', have: ' + poklon' },
    { qty: 4, pct: 10, get: ' + poklon + besplatnu dostavu', have: ' + poklon + besplatna dostava' }
  ];

  // Crni petak: poklon od 3 artikla se ne pominje dok traje akcija (poklon je uz svaki artikal)
  function bfOn() { return document.body.classList.contains('zv-bf'); }
  function tierExtra(t, key) {
    var s = (t && t[key]) || '';
    return bfOn() ? s.replace(' + poklon', '') : s;
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    var amount = Math.round(Number(cents || 0) / 100);
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' RSD';
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Shopify ponekad vraća greške na engleskom (npr. "Cart Error") - prikazujemo ih na srpskom
  function srError(msg) {
    msg = String(msg || '');
    if (!msg || /[a-z]{3,}/i.test(msg) && !/[čćšžđ]|korp|dostup|staviti|dodat/i.test(msg) && /(error|cannot|can.t|sold out|not available|already|unavailable|variant|quantity|invalid)/i.test(msg)) {
      if (/sold out|unavailable|not available/i.test(msg)) return 'Ovaj proizvod je trenutno rasprodat.';
      if (/quantity|can.t add|already/i.test(msg)) return 'Nema dovoljno komada na stanju za ovu količinu.';
      return 'Proizvod trenutno ne može da se doda u korpu. Osveži stranicu i pokušaj ponovo.';
    }
    return msg;
  }

  // Poruke validacije formi na srpskom (browser ih inače prikazuje na svom jeziku)
  document.addEventListener('invalid', function (e) {
    var el = e.target;
    if (!el || !el.validity || !el.setCustomValidity) return;
    var v = el.validity, m = '';
    if (v.valueMissing) m = 'Ovo polje je obavezno.';
    else if (v.typeMismatch && el.type === 'email') m = 'Unesi ispravnu email adresu, npr. ime@gmail.com.';
    else if (v.patternMismatch && el.type === 'tel') m = 'Unesi broj telefona, npr. +381 60 123 4567 ili 060 123 4567.';
    else if (v.patternMismatch || v.typeMismatch) m = 'Proveri format unosa.';
    else if (v.tooShort) m = 'Unos je prekratak.';
    else if (v.rangeUnderflow || v.rangeOverflow) m = 'Vrednost nije u dozvoljenom opsegu.';
    if (m) el.setCustomValidity(m);
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.setCustomValidity) e.target.setCustomValidity('');
  }, true);

  /* ---------- Crni petak: odbrojavanje i automatsko gašenje na kraju akcije ---------- */
  (function () {
    var marker = $('[data-zv-bf-end]');
    if (!marker) return;
    var end = Number(marker.getAttribute('data-zv-bf-end')) * 1000;
    var counters = $$('[data-zv-bf-count]');
    var timer;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(timer);
        document.body.classList.remove('zv-bf');
        return;
      }
      counters.forEach(function (el) {
        $('[data-d]', el).textContent = pad(Math.floor(left / 86400));
        $('[data-h]', el).textContent = pad(Math.floor(left % 86400 / 3600));
        $('[data-m]', el).textContent = pad(Math.floor(left % 3600 / 60));
        $('[data-s]', el).textContent = pad(left % 60);
      });
    }
    timer = setInterval(tick, counters.length ? 1000 : 60000);
    tick();
  })();

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'zv-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Korpa ---------- */
  function setCount(n) {
    $$('[data-header-cart-count]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.setAttribute('data-count', n);
    });
  }

  function addToCart(items, trigger, opts) {
    opts = opts || {};
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(srError(data.description || data.message));
        return data;
      });
    }).then(function (data) {
      var cartPromise = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.ZyraV2.lastCart = { cart: cart, t: Date.now() };
          setCount(cart.item_count);
          return cart;
        });
      // korpa se otvara odmah, a sadržaj se iscrtava čim stigne cart.js (jedan zahtev umesto dva)
      if (!opts.silent) document.dispatchEvent(new CustomEvent('zyra:editions-cart-added', { detail: { trigger: trigger, items: data.items, cartPromise: cartPromise } }));
      return cartPromise;
    });
  }
  window.ZyraV2 = { addToCart: addToCart, money: money, lastCart: null };

  // Preporuke "uz ovo se često kupuje": Shopify product recommendations (related) - iz porudžbina i sličnosti proizvoda
  var recsCache = {};
  var recsResolved = {};
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fetchRecs(productId) {
    if (!productId) return Promise.resolve([]);
    if (recsCache[productId]) return recsCache[productId];
    recsCache[productId] = fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return (j.products || []).filter(function (p) {
          return p.available && p.variants && p.variants.length === 1 && p.variants[0].available && !/poklon-vaucer/.test(p.handle);
        }).map(function (p) {
          var image = imgUrl(p.featured_image, 160);
          if (image) { var im = new Image(); im.src = image; }
          return { product_id: p.id, variant_id: p.variants[0].id, title: p.title, url: p.url || ('/products/' + p.handle), price: p.price, image: image };
        });
      })
      .then(function (list) { recsResolved[productId] = list; return list; })
      .catch(function () { return []; });
    return recsCache[productId];
  }
  window.ZyraV2.fetchRecs = fetchRecs;

  // Brzo dodavanje sa kartica
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-zv-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = $('button', form);
    btn.disabled = true;
    addToCart([{ id: Number(form.elements.id.value), quantity: 1 }], btn).then(function () {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
    }).catch(function (err) { toast(err.message); }).then(function () { btn.disabled = false; });
  });

  /* ---------- Header ---------- */
  var header = $('[data-zv-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Desktop mega meni: tastatura i dodir
    $$('[data-zv-mega-trigger]', header).forEach(function (btn) {
      var item = btn.closest('.zv-nav__item');
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'BUTTON') e.preventDefault();
        var open = !item.classList.contains('is-open');
        $$('.zv-nav__item.is-open', header).forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open);
      });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
  }

  // Drawer-i (meni, filteri)
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    // meni se uvek otvara od vrha (neki telefoni skroluju panel kad dobije fokus)
    var panel = $('.zv-drawer__panel, .zv-search__panel', d);
    if (panel) panel.scrollTop = 0;
    var f = $('[data-zv-autofocus]', d) || $('button, a, input', d);
    if (f) setTimeout(function () {
      try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
      if (panel) panel.scrollTop = 0;
    }, 60);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-zv-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-zv-open')); return; }
    var closer = e.target.closest('[data-zv-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.zv-drawer, .zv-search')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.zv-drawer.is-open, .zv-search.is-open').forEach(closeDrawer);
    var lb = $('.zv-lightbox.is-open');
    if (lb) lb.classList.remove('is-open');
  });

  /* ---------- Pretraga sa predlozima ---------- */
  var search = $('[data-zv-search]');
  if (search) {
    var input = $('input[name="q"]', search);
    var out = $('[data-zv-search-results]', search);
    var timer, lastQ = '';
    // Shopify dodaje _pos/_psq/_psid/_ss na linkove iz pretrage; kupcu dajemo čist URL kategorije/proizvoda
    function cleanUrl(u) { return String(u || '').split('?')[0]; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = out.getAttribute('data-default') || ''; return; }
      timer = setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data.resources.results;
            var html = '';
            if (res.collections && res.collections.length) {
              html += '<p class="zv-search__label">Kategorije</p><div class="zv-chips" style="padding:0 0 18px">' +
                res.collections.slice(0, 6).map(function (c) { return '<a class="zv-chip" href="' + esc(cleanUrl(c.url)) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
            }
            if (res.products && res.products.length) {
              html += '<p class="zv-search__label">Proizvodi</p><div class="zv-search__grid">' +
                res.products.slice(0, 10).map(function (p) {
                  var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
                  return '<a class="zv-search__item" href="' + esc(cleanUrl(p.url)) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
                    esc(p.title) + '<span class="zv-price">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
                }).join('') + '</div>';
              html += '<p style="margin-top:18px"><a class="zv-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">Svi rezultati za „' + esc(q) + '“</a></p>';
            }
            out.innerHTML = html || '<p class="zv-search__label">Nema rezultata za „' + esc(q) + '“</p>';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Rail strelice ---------- */
  function initRail(rail) {
    var track = $('[data-zv-rail-track]', rail);
    var prev = $('[data-zv-rail-prev]', rail);
    var next = $('[data-zv-rail-next]', rail);
    if (!track || !prev || !next) return;
    function update() {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }
  $$('[data-zv-rail]').forEach(initRail);

  /* ---------- Preporuke (asinhrono) ---------- */
  $$('[data-zv-recs]').forEach(function (sec) {
    if (sec.querySelector('.zv-card')) return;
    fetch(sec.getAttribute('data-zv-recs')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-zv-recs]');
      if (fresh && fresh.querySelector('.zv-card')) { sec.innerHTML = fresh.innerHTML; initRail(sec); }
    }).catch(function () {});
  });

  /* ---------- "Prikaži više" za SEO tekstove ---------- */
  $$('[data-zv-more]').forEach(function (box) {
    var body = $('.zv-more__body', box);
    var btn = $('.zv-more__toggle', box);
    var limit = parseInt(getComputedStyle(box).getPropertyValue('--zv-clamp'), 10) || 168;
    if (body.scrollHeight > limit + 40) {
      box.classList.add('is-clampable', 'is-clamped');
      btn.addEventListener('click', function () {
        var clamped = box.classList.toggle('is-clamped');
        btn.textContent = clamped ? 'Prikaži više' : 'Prikaži manje';
        btn.setAttribute('aria-expanded', !clamped);
      });
    }
  });

  /* ---------- Procena isporuke (1-3 radna dana) ---------- */
  var DAYS = ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'];
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  // Slanje: radnim danima do 14h isti dan, posle 14h sledeći radni dan; vikendom u ponedeljak.
  // Isporuka je 1-3 radna dana posle dana slanja. Računa se po vremenu u Srbiji.
  var CUTOFF_HOUR = 14;
  function belgradeNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Belgrade', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
    } catch (e) { return new Date(); }
  }
  function isWeekend(d) { return d.getDay() === 0 || d.getDay() === 6; }
  function shipDate(now) {
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (isWeekend(d) || now.getHours() >= CUTOFF_HOUR) {
      do { d.setDate(d.getDate() + 1); } while (isWeekend(d));
    }
    return d;
  }
  var SHIP_DAY = ['u nedelju', 'u ponedeljak', 'u utorak', 'u sredu', 'u četvrtak', 'u petak', 'u subotu'];
  function shipText(now, ship) {
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var diff = Math.round((ship - today) / 864e5);
    if (diff === 0) {
      var left = CUTOFF_HOUR * 60 - (now.getHours() * 60 + now.getMinutes());
      var h = Math.floor(left / 60), m = left % 60;
      return 'Poruči u narednih ' + [h ? h + 'h' : '', m ? m + 'min' : ''].filter(Boolean).join(' ') + ' i šaljemo danas.';
    }
    return 'Šaljemo ' + (diff === 1 ? 'sutra' : SHIP_DAY[ship.getDay()]) + '.';
  }
  window.ZyraV2.shipEstimate = function (now) {
    var ship = shipDate(now);
    return { ship: ship, from: addBusinessDays(ship, 1), to: addBusinessDays(ship, 3), text: shipText(now, ship) };
  };
  function renderEta() {
    var est = window.ZyraV2.shipEstimate(belgradeNow());
    $$('[data-zv-eta]').forEach(function (el) { el.textContent = fmt(est.from) + ' - ' + fmt(est.to); });
    $$('[data-zv-ship]').forEach(function (el) { el.textContent = est.text; el.hidden = false; });
  }
  renderEta();
  setInterval(renderEta, 60000);

  /* ---------- Stranica proizvoda ---------- */
  $$('[data-zv-pdp]').forEach(function (pdp) {
    var dataEl = $('[data-zv-product-json]', pdp);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    setTimeout(function () { fetchRecs(product.id); }, 1200);
    var form = $('[data-zv-product-form]', pdp);
    var idInput = form && form.elements.id;
    var atc = $('[data-zv-atc]', pdp);
    var atcLabel = atc && $('[data-zv-atc-label]', atc);
    var errorEl = $('[data-zv-error]', pdp);
    var gallery = $('[data-zv-gallery]', pdp);
    var main = gallery && $('[data-zv-gallery-main]', gallery);
    var slides = main ? $$('[data-media-id]', main) : [];
    var dots = gallery ? $$('[data-zv-dot]', gallery) : [];
    var thumbs = gallery ? $$('[data-zv-thumb]', gallery) : [];
    var counter = gallery && $('[data-zv-counter]', gallery);

    // Galerija
    function activeIndex() { return main ? Math.round(main.scrollLeft / main.clientWidth) : 0; }
    function markActive(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i, smooth) {
      if (!main || !slides[i]) return;
      main.scrollTo({ left: i * main.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      markActive(i);
    }
    if (main) {
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { markActive(activeIndex()); });
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      var prevB = $('[data-zv-gallery-prev]', gallery), nextB = $('[data-zv-gallery-next]', gallery);
      if (prevB) prevB.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
      if (nextB) nextB.addEventListener('click', function () { goTo(Math.min(slides.length - 1, activeIndex() + 1)); });
    }

    // Lightbox
    var lb = $('[data-zv-lightbox]', pdp);
    if (lb && main) {
      var lbTrack = $('.zv-lightbox__track', lb);
      main.addEventListener('click', function (e) {
        var slide = e.target.closest('[data-zv-zoom]');
        if (!slide) return;
        if (!lbTrack.children.length) {
          lbTrack.innerHTML = slides.filter(function (s) { return s.hasAttribute('data-zv-zoom'); }).map(function (s) {
            return '<img src="' + esc(s.getAttribute('data-zv-zoom')) + '" alt="">';
          }).join('');
        }
        lb.classList.add('is-open');
        var idx = slides.filter(function (s) { return s.hasAttribute('data-zv-zoom'); }).indexOf(slide);
        requestAnimationFrame(function () { lbTrack.scrollLeft = Math.max(0, idx) * lbTrack.clientWidth; });
      });
      $('[data-zv-lightbox-close]', lb).addEventListener('click', function () { lb.classList.remove('is-open'); });
    }

    // Količina
    var qty = $('[data-zv-qty]', pdp);
    if (qty) {
      var qInput = $('input', qty);
      $$('button', qty).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qInput.value, 10) || 1) + (b.getAttribute('data-step') === '+' ? 1 : -1));
          qInput.value = v;
        });
      });
    }

    // Varijante
    var optionInputs = $$('[data-zv-option] input', pdp);
    function currentOptions() {
      return $$('[data-zv-option]', pdp).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateAvailability(opts) {
      $$('[data-zv-option]', pdp).forEach(function (fs, idx) {
        $$('.zv-pill', fs).forEach(function (pill) {
          var val = $('input', pill).value;
          var test = opts.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
        var sel = $('[data-zv-option-selected]', fs);
        if (sel) sel.textContent = opts[idx] || '';
      });
    }
    function renderVariant(v) {
      var priceEl = $('[data-zv-price]', pdp);
      var wasEl = $('[data-zv-was]', pdp);
      var saveEl = $('[data-zv-save]', pdp);
      var stockEl = $('[data-zv-stock]', pdp);
      if (!v) {
        if (atc) { atc.disabled = true; atcLabel.textContent = 'Nedostupno'; }
        return;
      }
      idInput.value = v.id;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.textContent = money(v.price);
      priceEl.classList.toggle('zv-price--sale', !!sale);
      wasEl.hidden = !sale;
      saveEl.hidden = !sale;
      if (sale) {
        wasEl.textContent = money(v.compare_at_price);
        saveEl.textContent = 'Ušteda ' + money(v.compare_at_price - v.price);
      }
      $$('[data-zv-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
      var bn = $('[data-zv-buy-now]', pdp);
      if (bn) bn.disabled = !v.available;
      if (atc) {
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? atc.getAttribute('data-label') : 'Rasprodato';
      }
      if (stockEl) {
        var inv = stockEl.getAttribute('data-inventory-' + v.id);
        stockEl.className = 'zv-stock';
        if (!v.available) { stockEl.classList.add('zv-stock--out'); stockEl.textContent = 'Trenutno rasprodato'; }
        else if (inv && Number(inv) > 0 && Number(inv) <= 3) { stockEl.classList.add('zv-stock--low'); stockEl.textContent = 'Još samo ' + inv + ' na stanju'; }
        else { stockEl.textContent = 'Na stanju'; }
      }
      if (v.featured_media) {
        var i = slides.findIndex(function (s) { return Number(s.getAttribute('data-media-id')) === v.featured_media.id; });
        if (i > -1) goTo(i);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        var opts = currentOptions();
        updateAvailability(opts);
        renderVariant(findVariant(opts));
      });
    });
    if (optionInputs.length) updateAvailability(currentOptions());

    // Dodaj u korpu
    if (form) {
      var addFromForm = function (btn, opts) {
        if (errorEl) errorEl.hidden = true;
        var btns = [atc, btn].filter(Boolean);
        btns.forEach(function (b) { b.classList.add('is-loading'); });
        var fd = new FormData(form);
        var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && val !== '') props[m[1]] = val;
        });
        if (Object.keys(props).length) item.properties = props;
        if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
        return addToCart([item], btn || atc, opts).then(function () { return true; }, function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          toast(err.message);
          return false;
        }).then(function (ok) { btns.forEach(function (b) { b.classList.remove('is-loading'); }); return ok; });
      };
      var buyNow = $('[data-zv-buy-now]', pdp);
      if (buyNow) {
        buyNow.addEventListener('click', function () {
          if (buyNow.classList.contains('is-loading')) return;
          buyNow.classList.add('is-loading');
          addFromForm(null, { silent: true }).then(function (ok) {
            if (!ok) { buyNow.classList.remove('is-loading'); return; }
            // isti put kao dugme za plaćanje u korpi (POST /cart sa checkout), a ne GET /checkout
            var f = document.createElement('form');
            f.method = 'post';
            f.action = root + 'cart';
            f.innerHTML = '<input type="hidden" name="checkout" value="">';
            document.body.appendChild(f);
            f.submit();
          });
        });
        // povratak sa checkouta dugmetom „nazad“ (bfcache) ne sme da ostavi spinner
        window.addEventListener('pageshow', function (e) { if (e.persisted) buyNow.classList.remove('is-loading'); });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addFromForm(atc);
      });
    }

    // Sticky dugme (mobilni i desktop): pojavljuje se kad glavno dugme ode iznad ekrana
    var sticky = $('[data-zv-sticky]');
    if (sticky && atc) {
      var ticking = false;
      var checkSticky = function () {
        ticking = false;
        var show = atc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('zv-has-sticky', show);
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || setTimeout)(checkSticky);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      checkSticky();
      var stickyBtn = $('[data-zv-sticky-btn]', sticky);
      stickyBtn.addEventListener('click', function () {
        if (atc.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (optionInputs.length) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (stickyBtn.classList.contains('is-loading')) return;
        addFromForm(stickyBtn);
      });
    }
  });

  // Klik na zvezdice skroluje do recenzija
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-zv-scroll-reviews]');
    if (!a) return;
    var target = document.getElementById('zv-reviews') || $('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* ---------- Kolekcija: sortiranje i filteri ---------- */
  $$('[data-zv-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('[data-zv-filter-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(f).forEach(function (val, key) { if (val !== '') params.append(key, val); });
      var current = new URL(window.location.href).searchParams.get('sort_by');
      if (current) params.set('sort_by', current);
      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  });

  /* ---------- Dodaci u korpi: popust po količini i predlozi ---------- */
  var drawer = $('[data-zyra-cart-drawer]');
  var extras = $('[data-zv-cart-extras]');
  if (drawer && extras) {
    var upsellData = [];
    try { upsellData = JSON.parse(($('[data-zv-cart-upsell-json]') || {}).textContent || '[]'); } catch (err) { upsellData = []; }
    var busy = false;

    var note = $('[data-zv-cart-note]', drawer);
    function renderExtras(cart) {
      if (note && cart) {
        note.innerHTML = cart.total_price >= FREE_SHIPPING
          ? '<strong>Dostava je besplatna</strong> · Plaćanje pouzećem'
          : 'Besplatna dostava preko 5.999 RSD (inače 399 RSD) · Plaćanje pouzećem';
      }
      var tierEl = $('[data-zv-cart-tier]', drawer);
      if (!tierEl) {
        var ship = $('[data-zyra-cart-shipping]', drawer);
        if (ship) { tierEl = document.createElement('p'); tierEl.className = 'zv-cart-tier zv-cart-tier--pinned'; tierEl.setAttribute('data-zv-cart-tier', ''); ship.appendChild(tierEl); }
      }
      if (!cart || !cart.item_count) { extras.innerHTML = ''; if (tierEl) tierEl.hidden = true; return; }
      var html = '', tierHtml = '';
      var count = cart.item_count;
      var nextTier = TIERS.find(function (t) { return t.qty > count; });
      var currentTier = TIERS.slice().reverse().find(function (t) { return t.qty <= count; });
      // dostava je već besplatna preko 5.999 RSD - tada je ne nudimo kao nagradu za 4+ artikla
      var shipFree = cart.total_price >= FREE_SHIPPING;
      var extra = function (t, key) { var s = tierExtra(t, key); return shipFree ? s.replace(/ \+ besplatn\S+ dostav\S+/, '') : s; };
      if (nextTier) {
        var need = nextTier.qty - count;
        tierHtml = 'Dodaj još <strong>' + need + ' ' + (need === 1 ? 'artikal' : 'artikla') + '</strong> i ostvari <strong>-' + nextTier.pct + '% popusta' + extra(nextTier, 'get') + '</strong>' +
          (currentTier ? ' (sada imaš -' + currentTier.pct + '%' + extra(currentTier, 'have') + ')' : '') + '.';
      } else if (currentTier) {
        tierHtml = 'Super! Ostvaren je <strong>-' + currentTier.pct + '% popusta' + extra(currentTier, 'have') + '</strong> na porudžbinu.';
      }
      if (bfOn()) {
        var gifts = cart.items.reduce(function (n, i) { return i.gift_card ? n : n + i.quantity; }, 0);
        if (gifts) tierHtml = '<span class="zv-bf-cart">Crni petak: uz porudžbinu ' + (gifts > 1 && gifts < 5 ? 'stižu' : 'stiže') + ' <strong>' + gifts + ' gratis ' + (gifts === 1 ? 'poklon' : 'poklona') + '</strong></span>' + tierHtml;
      }
      if (tierEl) { tierEl.innerHTML = tierHtml; tierEl.hidden = !tierHtml; }
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var anchor = cart.items[0] && cart.items[0].product_id; // Shopify: poslednji dodat je prvi
      var recs = recsResolved[anchor];
      var fromRecs = !!(recs && recs.length);
      var source = fromRecs ? recs : upsellData;
      var picks = source.filter(function (p) { return inCart.indexOf(p.product_id) === -1; }).slice(0, 6);
      if (!fromRecs && anchor && !recsResolved.hasOwnProperty(anchor)) {
        // preporuke još nisu stigle: prikaži rezervne pa osveži kad stignu
        fetchRecs(anchor).then(function (list) {
          var latest = (window.ZyraV2.lastCart && window.ZyraV2.lastCart.cart) || cart;
          if (list.length) renderExtras(latest);
        });
      }
      if (picks.length && (cart.total_price < FREE_SHIPPING || nextTier)) {
        var upTitle = fromRecs ? 'Uz ovo se često kupuje' : (cart.total_price < FREE_SHIPPING ? 'Dopuni do besplatne dostave' : 'Popularno kod kupaca');
        html += '<div class="zv-cart-upsell"><p class="zv-cart-upsell__title">' + upTitle + '</p><div class="zv-cart-upsell__list">' +
          picks.map(function (p) {
            return '<div class="zv-cart-up"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="" width="56" height="56"></a>' +
              '<a class="zv-cart-up__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><strong>' + money(p.price) + '</strong>' +
              '<button type="button" data-zv-up-add="' + p.variant_id + '">+ Dodaj</button></div>';
          }).join('') + '</div></div>';
      }
      extras.innerHTML = html;
    }
    // Predlozi i poruka o popustu stoje ISPOD artikala, u delu korpe koji se skroluje
    // (korpa sama prepisuje svoj sadržaj, pa ih posle svakog iscrtavanja vraćamo na kraj)
    function placeExtras() {
      var b = $('[data-zyra-cart-body]', drawer);
      if (b && extras.parentNode !== b) b.appendChild(extras);
    }
    var renderExtrasInner = renderExtras;
    renderExtras = function (cart) { renderExtrasInner(cart); placeExtras(); };
    function refresh() {
      var last = window.ZyraV2.lastCart;
      if (last && Date.now() - last.t < 2000) { renderExtras(last.cart); return; }
      if (busy) return;
      busy = true;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(renderExtras).catch(function () {}).then(function () { busy = false; });
    }
    var body = $('[data-zyra-cart-body]', drawer) || $('.zyra-cart-drawer__body', drawer);
    if (body && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 0); }).observe(body, { childList: true });
    }
    extras.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zv-up-add]');
      if (!b) return;
      b.disabled = true;
      b.textContent = '…';
      addToCart([{ id: Number(b.getAttribute('data-zv-up-add')), quantity: 1 }], b).catch(function (err) { toast(err.message); b.disabled = false; b.textContent = '+ Dodaj'; });
    });
  }
})();

/* Traka podkategorija: trenutna kategorija uvek u vidnom polju (telefon) */
(function () {
  document.querySelectorAll('.zv-chips').forEach(function (row) {
    var a = row.querySelector('.is-active');
    if (!a || row.scrollWidth <= row.clientWidth) return;
    row.scrollLeft = Math.max(0, a.offsetLeft - row.offsetLeft - 16);
  });
})();

/* Dugmad za skrol unutar stranice (npr. vodič za veličinu prstena): bez linka i bez #oznake u adresi */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-zv-scroll-to]');
  if (!b) return;
  var id = b.getAttribute('data-zv-scroll-to');
  if (id === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
  var target = document.getElementById(id);
  if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* Newsletter u footeru: prijava bez ponovnog učitavanja stranice, bez skrola i bez ?customer_posted=true u adresi */
(function () {
  if (/[?&]customer_posted=true/.test(location.search)) {
    var clean = location.pathname + location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?');
    history.replaceState(null, '', clean === location.pathname + '?' ? location.pathname : clean);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-zv-newsletter]');
    if (!form || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (r) {
        // Shopify ponekad traži proveru (captcha): tada klasično slanje forme
        if (/\/challenge/.test(r.url)) { form.removeAttribute('data-zv-newsletter'); form.submit(); return null; }
        return r.text();
      })
      .then(function (html) {
        if (html == null) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(form.id);
        if (fresh) { form.innerHTML = fresh.innerHTML; }
        else { form.innerHTML = '<p class="zv-footer__msg">Hvala! Prijava je uspešna.</p>'; }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        form.removeAttribute('data-zv-newsletter');
        form.submit();
      });
  });
})();

/* Judge.me recenzije: aplikacija nema srpsku latinicu (podešen je hrvatski) - hrvatske reči menjamo srpskim.
   Radi samo na stranicama sa Judge.me blokom i prati samo taj blok (bez uticaja na brzinu ostatka sajta). */
(function () {
  var widgets = document.querySelectorAll('.jdgm-widget');
  if (!widgets.length) return;
  var FIX = [
    [/Provjeren/g, 'Proveren'], [/provjeren/g, 'proveren'],
    [/Ocjen/g, 'Ocen'], [/ocjen/g, 'ocen'],
    [/\bprije\b/g, 'pre'], [/\bPrije\b/g, 'Pre'],
    [/\btjedana\b/g, 'nedelja'], [/\btjedan\b/g, 'nedelju'],
    [/\bmjeseci\b/g, 'meseci'], [/\bmjesec\b/g, 'mesec'],
    [/izvan trgovine/g, 'van prodavnice'], [/\btrgovine\b/g, 'prodavnice'], [/\btrgovina\b/g, 'prodavnica'],
    [/Osvježi/g, 'Osveži'], [/Temeljeno na/g, 'Na osnovu'],
    [/\bvaljanu\b/g, 'ispravnu'], [/\bovdje\b/g, 'ovde'], [/\bopcionalno\b/g, 'opciono'],
    [/Počnite pisati/g, 'Počnite da pišete'], [/Zalijepite/g, 'Nalepite'],
    [/Анониман/g, 'Anonimno']
  ];
  function fixText(s) { for (var i = 0; i < FIX.length; i++) s = s.replace(FIX[i][0], FIX[i][1]); return s; }
  function fixIn(el) {
    try {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { var t = fixText(n.nodeValue); if (t !== n.nodeValue) n.nodeValue = t; }
      Array.prototype.forEach.call(el.querySelectorAll('[placeholder]'), function (f) {
        var p = f.getAttribute('placeholder') || '', q = fixText(p);
        if (q !== p) f.setAttribute('placeholder', q);
      });
    } catch (e) { /* prevod nije bitan za rad sajta */ }
  }
  Array.prototype.forEach.call(widgets, function (wd) {
    fixIn(wd);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      setTimeout(function () { queued = false; fixIn(wd); }, 150);
    }).observe(wd, { childList: true, subtree: true });
  });
  // forma za recenziju se otvara kao prozor van bloka: sredi je posle klika na dugme
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.jdgm-widget')) return;
    [400, 1200].forEach(function (ms) {
      setTimeout(function () {
        var SEL = '[class*="jdgm"], [class*="jm-"]';
        Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
          if (!(el.parentElement && el.parentElement.closest(SEL))) fixIn(el);
        });
      }, ms);
    });
  });
})();
